import { Link } from "react-router-dom";

const Amlkyc = () => {
  return (
    <>
      {/* <!--hero part start here!--> */}

      <section className="hearo-wrap hero-inner">
        <div className="container">
          {/* <!--=========Bread Crum!=====================--> */}
          <div className="bread-crum">
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  AML/KYC Policy{" "}
                </li>
              </ol>
            </nav>
          </div>
          {/* <!--=========Bread Crum!=====================--> */}
        </div>

        <div className="container hero-bx padding-top-bot">
          {/* <!--exchange part!--> */}

          <div className="row justify-content-center">
            <div className="col-md-7">
              <h1 className="hero-title">AML/KYC Policy</h1>
              <p>
                This page outlines the Anti-Money Laundering (AML) and Know Your
                Customer (KYC) measures implemented on the Kittrow Investments s.r.o. platform
              </p>
            </div>
          </div>
        </div>
        {/* <!--exchange part!--> */}
      </section>

      {/* <!--===================FAQ page!======================--> */}

      <section className="container aml-page sec-pad-t">
        <div className="row justify-content-center">
          <div className="col-xl-7">
            <h2 className="sec-title">Why AML and KYC Matter</h2>
            <h3 className="sm-title">The Foundation of Trust</h3>
            <p>
              AML and KYC policies are not just bureaucratic requirements — they
              are the foundation of trust between a platform and its users.
            </p>

            <p>
              By verifying users' identities and monitoring transactions,
              Kittrow Investments s.r.o. prevents the platform from being used for illicit
              activities such as money laundering, terrorism financing, tax
              evasion, or fraud.
            </p>

            <div className="cnt-divider"></div>

            <h2 className="sec-title">KYC Procedure at Kittrow Investments s.r.o.</h2>
            <h3 className="sm-title">Identity Verification Steps</h3>
            <p>
              Each user is required to undergo a simple verification process
              before making exchanges. This helps us confirm that every
              transaction is performed by a real, verified individual.
            </p>
            <h4>Required Documents</h4>
            <p>To complete KYC, you may be asked to provide:</p>
            <p className="p-wt-img">
              <img src="assets/images/star.png" />A valid government-issued
              photo ID (e.g. passport)
            </p>
            <p className="p-wt-img">
              <img src="assets/images/star.png" />
              Proof of address (not older than 3 months)
            </p>
            <p>
              In some cases, we may request a selfie with your ID to ensure
              authenticity.
            </p>

            <div className="cnt-divider"></div>
            <h2 className="sec-title">AML Monitoring and Controls</h2>
            <h3 className="sm-title">Transaction Oversight</h3>
            <p>
              Kittrow Investments s.r.o. has a built-in system that continuously monitors
              transactions for unusual behavior. If suspicious activity is
              detected, the system may flag the transaction for manual review.
            </p>
            <h3 className="sm-title">Compliance and Reporting</h3>
            <p>
              We comply with local and international regulations and report
              suspicious transactions to the relevant authorities when required
              by law.
            </p>

            <div className="cnt-divider"></div>
            <h2 className="sec-title">Timing and Security</h2>
            <h3 className="sm-title">Average Verification Time</h3>
            <p>
              In most cases, verification is completed within 5 to 30 minutes.
              If your case requires manual review, it may take up to 24 hours.
            </p>
            <h3 className="sm-title">Data Security</h3>
            <p>
              All your information is encrypted and stored securely. Access is
              granted only to authorized personnel, and we never share your data
              with third parties unless legally obligated.
            </p>
            <div className="cnt-divider"></div>

            <h2 className="sec-title">Summary: What You Need</h2>
            <p>
              To start exchanging on Kittrow Investments s.r.o., you only need a few essentials:
            </p>
            <p className="num-p">
              <span>1.</span> A valid email address
            </p>
            <p className="num-p">
              <span>2.</span> A crypto wallet
            </p>
            <p className="num-p">
              <span>3.</span> A passport or national ID
            </p>
            <p>
              We've designed the process to be quick, clear, and non-technical.
            </p>

            <div className="cnt-divider"></div>
            <h2 className="sec-title">Contact Us</h2>
            <p>
              If you have any questions regarding this policy or need help with
              verification
            </p>
            <p>
              Email: <a href="#">support@kittrowinvest.com</a>
            </p>
            <div className="cnt-divider"></div>

            {/* <div className="photo">
              <img src="assets/images/placeholder-photo.png" alt="" />
            </div> */}
          </div>
        </div>

        {/* <!--===================help section!=================--> */}
        <div className="sec-pad-t">
          <div className="swap-part help-faq">
            <div className="row justify-content-center">
              <div className="col-xl-7 col-md-10">
                <h2>
                  Still have questions? <br />
                  We're here to help.
                </h2>
                <p>
                  Our support team is always ready to assist you. Reach out —
                  we’ll respond quickly and clearly.
                </p>
                <div className="button-group">
                  <Link to="/contact-us" className="btn lm-btn">
                    Contact support
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="sec-pad-t"></div>
      {/* <!--=============Spacer!===========--> */}
    </>
  );
};

export default Amlkyc;
